import styled from 'styled-components';

export const Toolbar = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export const Count = styled.span`
  font-size: 12px;
  color: #595959;
`;

export const ToolbarActions = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const GroupedTable = styled.div`
  .ant-table-thead > tr:first-child > th {
    padding: 6px 8px;
    font-size: 11px;
    font-weight: 700;
    color: #595959;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    background: #f0f0f0;
  }

  .ant-table-tbody > tr:nth-child(even) > td {
    background: #fafafa;
  }

  .ant-table-tbody > tr.ant-table-row {
    cursor: pointer;
  }
`;
